import { render, staticRenderFns } from "./equipment.vue?vue&type=template&id=be4aef98&scoped=true"
import script from "./equipment.vue?vue&type=script&lang=js"
export * from "./equipment.vue?vue&type=script&lang=js"
import style0 from "./equipment.vue?vue&type=style&index=0&id=be4aef98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4aef98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be4aef98')) {
      api.createRecord('be4aef98', component.options)
    } else {
      api.reload('be4aef98', component.options)
    }
    module.hot.accept("./equipment.vue?vue&type=template&id=be4aef98&scoped=true", function () {
      api.rerender('be4aef98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components-cool/equipment.vue"
export default component.exports